import { useSnapshot } from 'valtio'
import { useResponsive } from 'ahooks'
import { configState } from '@/store'
import QuickHints from './QuickHints'
import styles from './index.module.less'

import HotLeftTitle from '@/assets/images/icon/hot-left-title.svg'
// import ArrawRightIcon from '@/assets/images/icon/arraw_right_icon.svg'
import HotHelper from './hotHelper'
const bannerDesc: string =
  '🤖 中国科学院自动化研究所和武汉人工智能研究院推出新一代多模态大模型\n🔬 全新【交互思考】功能上线，让你的深度思考图文结合'

export default function InitMessage() {
  const responsive = useResponsive()
  const { bannerData } = useSnapshot(configState)
  let defaultDesc: string =
    bannerData?.introducer2 || '我是紫东太初4.0多模态大模型。'
  let colorTitle: string = '紫东太初4.0'
  let nomalSplitList: string[] = []
  if (defaultDesc.includes(colorTitle)) {
    nomalSplitList = defaultDesc.split(colorTitle)
  }

  return (
    <div className={`${styles.initMessage}`}>
      <div className="relative">
        <div className={styles.title}>
          <div>{bannerData?.introducer1 || '你好，'}</div>
          <div>
            {nomalSplitList.length > 1 ? (
              <>
                {nomalSplitList[0]}
                <span
                  style={{
                    background:
                      'linear-gradient(to right, #9747FF 0%, #7B61FF 50%, #2E90FA 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                  }}
                >
                  {colorTitle}
                </span>
                {nomalSplitList[1]}
              </>
            ) : (
              defaultDesc
            )}
          </div>
        </div>
        <img
          src={HotLeftTitle}
          className="absolute top-0 -left-4 md:-left-7 size-4 md:size-7"
        />
        <div className={styles.subText}>
          {(() => {
            const text = bannerData?.introduction || bannerDesc
            const lines = text.split('\n')
            const result: JSX.Element[] = []

            lines.forEach((element: string, index: number) => {
              if (index !== lines.length - 1) {
                result.push(
                  <div key={index} className={styles.textLine}>
                    {element}
                  </div>,
                )
              } else {
                result.push(
                  <div key={index} className={styles.textLineWithButton}>
                    <span>{element}</span>
                    {/* { isThinkingWithImages && (
                      <div className={styles.experienceButton} onClick={handleQueryThinkingWithImages}>
                        <span className={styles.experienceText}>立即体验</span>
                        <img src={ArrawRightIcon} className={styles.experienceArrow} />
                      </div>
                    )} */}
                  </div>,
                )
              }
            })

            return <>{result}</>
          })()}
        </div>
      </div>
      <div className="flex gap-3 mt-5 md:mt-10">
        {responsive.md && <HotHelper />}
        <QuickHints />
      </div>
    </div>
  )
}
